import React from "react";
import axios from 'axios';

import { store } from "../../redux/store";
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";
import history from "../../auth/history";
import './Subtransaction.css';
import './MoneyTransfer.css';
import FooterComponet from "../FooterComponent/FooterComponet";
import SubTransactionDetails from "./SubTransactionDetails";
import OrderDetails from "./OrderDetails";
import TransferDetails from "./TransferDetails";
import AccountReview from "./AccountReview";
import $ from "jquery";
import moment, { max } from "moment";
import { v4 as uuidv4 } from 'uuid';
import tokenErrorHandler from "../tokenErrorHandler";
import { setMoneyTransferResponse } from './../../redux/response/response.action';
import { selectedSender, setMoneyTransferProgress, setTxnAmount, setTxnsurcharge, setTxntotalAmount, setStatusEnqResponse } from './../../redux/misc-data/misc-data.action';
import ProgressGif from '../../assests/images/progress.gif';
import ProgressStatic from '../../assests/images/progress.jpg';
import MtFailed from '../../assests/images/mtfailed.png';
import MtSuccess from '../../assests/images/mtsuccess.png';
import MtPartial from '../../assests/images/mtpartial.png';
import BankLogo from "../../assests/images/bank-logo.png";
import Avatar from 'react-avatar';
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";

const httpClient = axios.create();

class MoneyTransferDetails extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			moneyTransferFinalStatusCompleted: false,
			finalTransferMessage: '',
			orderMsg: '',
			thirdPartyMsg: ''
		}
	}


	componentDidMount() {

		store.dispatch(setTxnAmount(''));
		store.dispatch(setTxnsurcharge(''));
		store.dispatch(setTxntotalAmount(''));


		store.dispatch(setMoneyTransferProgress(''));
		store.dispatch(setStatusEnqResponse(''));
		var counter = 0;
		var statusEnqInterval = '';
		this.statusEnquiry();

		statusEnqInterval = setInterval(() => {


			counter++;
			console.log('counter value...' + counter);

			if (counter <= 11) {
				//store.dispatch(setMoneyTransferProgress('gap'));

				this.statusEnquiry(statusEnqInterval);
			} else {
				// alert(counter);
				console.log('clearing interval after 1 minute');
				clearInterval(statusEnqInterval);
				store.dispatch(setMoneyTransferProgress('statusEnquirycompletedInpendingStatus'));
			}
		}, 5000);
	}


	statusEnquiry = (statusEnqInterval) => {
		console.log(this.props.moneyTransferProgress)



		if ((this.props.moneyTransferProgress == 'pending'
			|| this.props.moneyTransferProgress == '')) {
			this.setState({
				progess: 'start'
			});

			store.dispatch(setMoneyTransferProgress('start'));

			var enquiryUrl = '/api/v1/dmt/order/enquiry/order-id/'
				+ this.props.createOrderRes.orderId
				;

			const headers = {
				'Authorization': 'Bearer ' + this.props.token,
				'client-id': this.props.agentInfo.id,
				'role': this.props.clientRole
			}

			httpClient.get(enquiryUrl, {
				timeout: 60 * 1000,
				timeoutErrorMessage: 'timeout',
				headers
			}
			).then((response) => {


				console.log('enquiry response' + JSON.stringify(response.data));
				if (response.data.response.success == true) {
					console.log('enquiry service success response:' + JSON.stringify(response.data));
					store.dispatch(setStatusEnqResponse(response.data));

					var txnAmount = 0;
					var surcharge = 0;
					var subOrderStatusList = [];

					this.setState({
						orderMsg: response.data.response.displayMsg,
						thirdPartyMsg: response.data.response.tpsRspMsg
					})

					response.data.subOrders.map(suborder => {

						if (suborder.status == 'SUCCESS') {
							txnAmount = txnAmount + parseInt(suborder.txnDetails.amount);
							surcharge = surcharge + parseInt(suborder.txnDetails.surcharge);

							var totalTxnAmount = txnAmount + surcharge;
							store.dispatch(setTxnAmount(txnAmount));
							store.dispatch(setTxnsurcharge(surcharge));
							store.dispatch(setTxntotalAmount(totalTxnAmount));
							// alert(totalTxnAmount);

						}

						subOrderStatusList.push(suborder.status.toUpperCase());

						console.log('suorder status::' + subOrderStatusList);


					})
					if (subOrderStatusList.includes("INIT")) {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));
					} else if (subOrderStatusList.includes("SYSTEM_BUSY")) {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));

					}
					else if (subOrderStatusList.includes("SUBMITTED")) {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));

					} else if (subOrderStatusList.includes("REVERSED")) {
						this.setState({
							progess: 'failed'
						})
						store.dispatch(setMoneyTransferProgress('failed'));
					}
					else if (subOrderStatusList.includes("SUCCESS") && !subOrderStatusList.includes("FAIL")) {
						console.log('all suborder success');
						this.setState({
							progess: 'finished'
						})
						store.dispatch(setMoneyTransferProgress('finished'));
					} else if (!subOrderStatusList.includes("SUCCESS") && subOrderStatusList.includes("FAIL")) {
						console.log('all suborder failed');
						this.setState({
							progess: 'failed'
						})
						store.dispatch(setMoneyTransferProgress('failed'));
					} else if (subOrderStatusList.includes("SUCCESS") && subOrderStatusList.includes("FAIL")) {
						console.log('partial success');
						this.setState({
							progess: 'partial success'
						})
						store.dispatch(setMoneyTransferProgress('partial success'));
					} else {
						this.setState({
							progess: 'pending'
						})
						store.dispatch(setMoneyTransferProgress('pending'));
					}

				} else if (response.data.response.success == false) {
					console.log('enquiry service failed response :' + JSON.stringify(response.data));
					store.dispatch(setStatusEnqResponse(response.data));
					this.setState({
						progess: 'failed'
					})

					this.setState({
						orderMsg: response.data.response.displayMsg,
						thirdPartyMsg: response.data.response.tpsRspMsg
					})
					store.dispatch(setMoneyTransferProgress('failed'));

				} else {
					store.dispatch(setStatusEnqResponse(response.data));
					console.log('enquiry service other response :' + JSON.stringify(response.data))
					this.setState({
						progess: 'pending'
					})

					this.setState({
						orderMsg: response.data.response.displayMsg,
						thirdPartyMsg: response.data.response.tpsRspMsg
					})

					store.dispatch(setMoneyTransferProgress('pending'));
				}
				//
			}).catch(error => {
				this.setState({
					progess: 'pending'
				})
				store.dispatch(setMoneyTransferProgress('pending'));
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				} else {

				}
				console.log('enquiry response error::' + error);
			})
		} else {
			console.log('clearing interval as response status is:' + this.props.moneyTransferProgress);
			clearInterval(statusEnqInterval);
		}
	}

	componentWillUnmount() {
	}


	print = (event) => {
		event.preventDefault();
		window.print();
	}


	render() {


		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">


							<div class="row">
								<div class="col-12">
									<div class="card-b" id="rightdiv">
										<div id="recenttxn">
											<div class="head">
												<h3>Money Transfer Details</h3>
												<Link to='/dmt'>
													<button class="dbbtn" type="button">Back</button>
												</Link>

											</div>
											<div class="benedtls">
												<div class="row">

													<div class="col-12 col-lg-4 order-lg-2">
														{(this.props.moneyTransferProgress == 'pending' ||
															this.props.moneyTransferProgress == 'start' ||
															this.props.moneyTransferProgress == '') &&
															<div class="mtprogess" id="mtrun">
																<img src={ProgressGif} alt="process" class="img-fluid" />
																<h3 class="pending">Money transfer in process...Do not refresh!</h3>
															</div>
														}
														{this.props.moneyTransferProgress == 'finished' &&
															<div class="mtprogess" id="mtdone">
																<img src={MtSuccess} alt="process" class="img-fluid" />
																<h3 class='success'>Money has been transferred successfully!</h3>
															</div>
														}
														{this.props.moneyTransferProgress == 'failed' &&
															<div class="mtprogess" id="mtfailed">
																<img src={MtFailed} alt="process" class="img-fluid" />
																<h3 class="failed">Money transfer failed!</h3>
															</div>
														}

														{this.props.moneyTransferProgress == 'statusEnquirycompletedInpendingStatus' &&
															<div class="mtprogess" id="mtdone">
																<img src={ProgressStatic} alt="process" class="img-fluid" />
																<h3 class="pending">Order is Pending, Please check Transaction History for Final Status</h3>
															</div>
														}

														{this.props.moneyTransferProgress == 'partial success' &&
															<div class="mtprogess" id="mtdone">
																<img src={MtPartial} alt="process" class="img-fluid" />
																<h3 class="partial">Money transfer partial success!</h3>
															</div>
														}
													</div>


													<div class="col-12 col-md-6 col-lg-4 order-lg-1">
														<div class="graycard">
															<div class="bankdtl">
																<Avatar name={this.props.selectSender.customer.name} round={true} size="44" alt="" />
																<h5>Sender Name</h5>
																<p>{this.props.selectSender.customer.name}</p>

															</div>
															<hr />
															<div class="bankdtl">
																<h5>Mobile Number</h5>
																<p>{this.props.selectSender.customer.mobile}</p>
															</div>
														</div>
													</div>

													<div class="col-12 col-md-6 col-lg-4 order-lg-3">
														<div class="graycard">
															<div class="bankdtl">
																{(this.props.benefisciaryInfo.bankName != null && this.props.benefisciaryInfo.bankName != null &&
																	this.props.bankLogoListTxt.includes(this.props.benefisciaryInfo.bankName.split(' ').join("-") + ".PNG")) ?
																	<img src={'/bank_images/' + this.props.benefisciaryInfo.bankName.toLowerCase().split(' ').join("-") + ".png"} alt="bank" /> :
																	<img src={BankLogo} alt="bank" />
																}

																<h5>{this.props.benefisciaryInfo.name}</h5>
																<p>{this.props.benefisciaryInfo.bankName}</p>
															</div>
															<hr />
															<div class="acntifsc">
																<h5>Account Number</h5>
																<p>{this.props.benefisciaryInfo.accountNumber}</p>
															</div>

															<div class="acntifsc rtxt">
																<h5>IFSC Code</h5>
																<p>{this.props.benefisciaryInfo.ifscCode}</p>
															</div>
														</div>
													</div>
												</div>
											</div>


											<div class="subtxn">
												{this.props.createOrderStatusResponse != null &&
													this.props.createOrderStatusResponse != undefined &&
													this.props.createOrderStatusResponse != '' &&
													this.props.createOrderStatusResponse.subOrders != null &&
													this.props.createOrderStatusResponse.subOrders.length > 0 &&
													<h4>Sub Transactions</h4>
												}

												{(this.props.createOrderStatusResponse != null &&
													this.props.createOrderStatusResponse != undefined &&
													this.props.createOrderStatusResponse != '') &&
													this.props.createOrderStatusResponse.subOrders != null &&
													this.props.createOrderStatusResponse.subOrders.length > 0 &&
													this.props.createOrderStatusResponse.subOrders.map(txRsp => (
														<div class={(txRsp.status == 'PENDING' || txRsp.status == 'INIT' ||
															txRsp.status == 'SUBMITTED' ||
															txRsp.status == 'SYSTEM_BUSY'
														) ? 'subtxn-pending' :
															txRsp.status == 'REVERSED' ? 'subtxn-failed' :
																txRsp.status == 'SUCCESS' ? 'subtxn-success' :
																	txRsp.status == 'FAILED' && 'subtxn-failed'}>
															<div class="row">
																<div class="col-6 col-md-3 col-lg-4 order-md-1">
																	<div class="subtxt txnsts">{(txRsp.status == 'PENDING' || txRsp.status == 'INIT' ||
																		txRsp.status == 'SUBMITTED' ||
																		txRsp.status == 'SYSTEM_BUSY') ? 'Pending' :
																		txRsp.status == 'REVERSED' ? 'Failed' :
																			txRsp.status == 'SUCCESS' ? 'Success' :
																				txRsp.status == 'FAILED' && 'Failed'}</div>
																</div>


																<div class="col-6 col-md-2 col-lg-2 order-md-4">
																	<div class="subtxt subamunt rtxt">₹ {txRsp.txnDetails.amount}</div>
																</div>

																<div class="col-12 col-md-4 col-lg-3 order-md-2">
																	<div class="subtxt subid">Transaction ID: {txRsp.id}</div>
																</div>

																<div class="col-12 col-md-3 col-lg-3 order-md-3">
																	<div class="subtxt">{moment(this.props.createOrderStatusResponse.time).format('DD-MM-YYYY HH:mm:ss')}</div>
																</div>
															</div>

															{txRsp.status != 'SUCCESS' &&
																txRsp.supplierRsp != null &&
																txRsp.supplierRsp != '' &&
																txRsp.supplierRsp != undefined &&
																<div class="row">
																	<br />

																	<b>
																		{txRsp.supplierRsp != '' && txRsp.supplierRsp != null && txRsp.supplierRsp != undefined && txRsp.status.toLowerCase() != 'success' &&
																			<div class="col-12">
																				<div class="subtxt txnsts">
																					{txRsp.supplierRsp.toLowerCase().includes("displaymsg") ?
																						txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
																							txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
																							.includes("message") ?
																							txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
																								txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
																								.substring(txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
																									txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "").indexOf("message"),
																									txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
																										txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "").length)
																							:
																							txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("displaymsg"),
																								txRsp.supplierRsp.length).replace("displaymsg:", "").replace("displaymsg-", "")
																						:
																						txRsp.supplierRsp.toLowerCase().includes("message") ?
																							txRsp.supplierRsp.toLowerCase().substring(txRsp.supplierRsp.toLowerCase().indexOf("message"),
																								txRsp.supplierRsp.length).replace("message:", "").replace("message-", "") :
																							txRsp.supplierRsp.toLowerCase()}
																				</div>
																			</div>
																		}
																	</b>
																</div>

															}



														</div>
													))}
												{/* {this.props.createOrderStatusResponse != null &&
													this.props.createOrderStatusResponse != undefined &&
													this.props.createOrderStatusResponse != '' &&
													(this.props.moneyTransferProgress == 'pending' ||
														this.props.moneyTransferProgress == 'statusEnquirycompletedInpendingStatus'
														|| this.props.moneyTransferProgress == 'partial success') ?
													<div class="col-12">
														<div class="subtxn-pending">
															{this.state.orderMsg != null &&
																this.state.orderMsg != '' &&
																this.state.orderMsg != undefined &&
																<b> Message:  {this.state.orderMsg}
																</b>
															}
															<br />

															{this.state.thirdPartyMsg != null &&
																this.state.thirdPartyMsg != '' &&
																this.state.thirdPartyMsg != undefined &&
																<b> Third Party Message:  {this.state.thirdPartyMsg}
																</b>
															}



														</div>
														
													</div>
													:
													this.props.moneyTransferProgress == 'failed' &&
													<div class="col-12">
														<div class="subtxn-failed">
															{this.state.orderMsg != null &&
																this.state.orderMsg != '' &&
																this.state.orderMsg != undefined &&
																<b> Message:  {this.state.orderMsg}
																</b>
															}
															<br />

															{this.state.thirdPartyMsg != null &&
																this.state.thirdPartyMsg != '' &&
																this.state.thirdPartyMsg != undefined &&
																<b> Third Party Message:  {this.state.thirdPartyMsg}
																</b>
															}


														</div>
														
													</div>
												} */}

											</div>



											{this.props.createOrderRes != '' &&
												<div class="paydtl">
													<div class="row">
														<div class="col-12 col-sm-6">
															<div class="orderdetail">
																<div class="txnhead">Order Details</div>
																<div class="odramt">
																	<p>Order Amount <span>₹ {parseFloat(this.props.transferTotalAmount) - parseFloat(this.props.surcharge)}</span></p>
																	<p>Surcharge <span>₹ {parseFloat(this.props.surcharge)}</span></p>
																</div>
																<div class="ttlamt">
																	<p>Total Amount <span>₹ {parseFloat(this.props.transferTotalAmount)}</span></p>
																</div>
															</div>
														</div>
														<div class="col-12 col-sm-6">
															<div class="tnsfrdetail">
																<div class="txnhead">Transfer Details</div>
																<div class="odramt">
																	<p>Transfer Amount <span>₹ {this.props.txmAmnt != '' ? parseFloat(this.props.txmAmnt) : 0.00}</span></p>
																	<p>Surcharge <span>₹ {this.props.txnSurchrg != '' ? parseFloat(this.props.txnSurchrg) : 0.00}</span></p>
																</div>
																<div class="ttlamt">
																	<p>Total Amount <span>₹ {this.props.txnTotalAmnt != '' ? parseFloat(this.props.txnTotalAmnt) : 0.00}</span></p>
																</div>
															</div>
														</div>
													</div>
												</div>
											}


											<div class="txn-btn">
												<button type="button" class="print" onClick={this.print}>Print</button>
												<button type="button" class="help"></button>
											</div>


										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<FooterComponet />
			</div>

		);
	}
}


const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, moneyTransferResponseDetails,
			createOrderResponseDetails, agentInfo, token, clientRole,
			selectSender, benefisciaryInfo,
			createOrderRes, transferTotalAmount, surcharge,

			txmAmnt,
			txnSurchrg,
			txnTotalAmnt,
			moneyTransferProgress,
			createOrderStatusResponse,
			bankLogoListTxt,
			callBackUrl
		}
	}
) => ({
	errorMessage, loginErrorMessage, phone, moneyTransferResponseDetails,
	createOrderResponseDetails, agentInfo, token, clientRole, selectSender,
	benefisciaryInfo,
	createOrderRes, transferTotalAmount, surcharge,

	txmAmnt,
	txnSurchrg,
	txnTotalAmnt,
	moneyTransferProgress,
	createOrderStatusResponse,
	bankLogoListTxt,
	callBackUrl
});

export default connect(mapStateToProps, null)(MoneyTransferDetails);
